import axios from "axios";
import url from "../config/url";
import { coverIMGSET, coverIMG } from "../util/helper"

export async function getInit() {
    try {
        const config = {
            method: 'get',
            url: url.main_url,
        };

        const { data } = await axios(config);
        if (data.code === 0) {
            // 返回一个数组处理栏目名称和id
            console.log(data)
            const arr = [];

            //筛选扩展字段
            for (const item of data.result.content) {
                // 扩展字段长度不等于0
                if (item.extFieldsList.length != 0) {
                    const tags_name = item.extFieldsList.find(e => e.label == '标签名');
                    const tags_id = item.extFieldsList.find(e => e.label == '分类id');
                    // 获取栏目类型
                    let tags_type = item.extFieldsList.find(e => e.label == '栏目类型');
                    tags_type = tags_type ? tags_type.fieldValue : false;

                    // 获取栏目图片
                    let tags_img = item.extFieldsList.find(e => e.label == '栏目图片');
                    tags_img = tags_img ? tags_img.fieldValue : false;

                    // 如果同时不为空
                    if (tags_name && tags_id) {
                        arr.push({
                            id: item.id,
                            tags_name: tags_name.fieldValue,
                            tags_id: tags_id.fieldValue,
                            tags_type,
                            tags_img
                        });
                    }
                }
            }
            return {
                state: 1,
                message: "获取初始化数据成功！",
                data: arr
            }

        } else {
            return {
                state: 0,
                message: "初始化失败！0"
            }
        }

    } catch (error) {
        console.log(error);
        return {
            state: 0,
            message: "初始化失败！"
        }
    }
}

// 获取河南24小时文章
export async function getHour24() {
    try {
        const config = {
            method: 'get',
            url: `https://yxwpubmod.hntv.tv/mobile/cms/articles?channelId=1382494036165791744&tenantId=hnr&pageNo=1&pageSize=4`,
        };

        const { data } = await axios(config);
        if (data.code === 0) {
            // 返回一个数组处理栏目名称和id
            const arr = [];

            //筛选扩展字段
            for (const item of data.result.content) {
                arr.push(handleArticles(item))
            }
            return {
                state: 1,
                message: "获取列表成功！",
                data: {
                    channelId: "1382494036165791744",
                    // 当前页数
                    page: data.result.pageNo,
                    // 总页数
                    totalPage: data.result.totalPage,
                    list: arr
                }
            }

        } else {
            return {
                state: 0,
                message: "获取列表失败！1"
            }
        }

    } catch (error) {
        console.log(error);
        return {
            state: 0,
            message: "获取列表失败！2"
        }
    }
}

// 获取专题的基本信息
export async function getZhuantiInit(atricleID) {
    try {
        const config = {
            method: 'get',
            url: `https://yxwpubmod.hntv.tv/mobile/cms/articlewithrelated?articleId=${atricleID}`,
        };

        const { data } = await axios(config);
        if (data.code === 0) {
            // 返回一个数组处理栏目名称和id
            const zhuanti_info = {
                articleId: data.result.articleId,
                title: data.result.articleTitle,
                des: data.result.seoDescription,
                url: data.result.forwardingUrl,
                // 开启时间线
                type: handleEXT(data.result.extFieldsList, '类型'),
                // 标签名
                zhuantiTagName: handleEXT(data.result.extFieldsList, '专题标签名', '专题'),
                coverIMG: coverIMGSET(data.result.coverImagesList),
                // 时间线标签名
                timelineName: handleEXT(data.result.extFieldsList, '时间线名称', '时间线'),
            }
            const arr = [];

            if (data.result.specialDTO && data.result.specialDTO["list"] && data.result.specialDTO["list"].length != 0) {
                //筛选扩展字段
                for (const tag_item of data.result.specialDTO.list) {

                    const tag = {
                        id: tag_item.tag,
                        tagName: tag_item.tag,
                        list: []
                    }

                    for (const item of tag_item.articleDTOList) {

                        // 扩展字段长度不等于0
                        tag.list.push(handleArticles(item));

                    }
                    arr.push(tag);
                }
            }

            const result = {
                state: 1,
                message: "获取专题数据成功！",
                data: {
                    ...zhuanti_info,
                    tags: arr
                }
            };

            console.log(result)

            return result

        } else {
            return {
                state: 0,
                message: "初始化失败！0"
            }
        }

    } catch (error) {
        console.log(error);
        return {
            state: 0,
            message: "初始化失败！"
        }
    }
}

// 获取专题时间线
export async function getZhuantiTimeline(atricleID) {
    try {
        const config = {
            method: 'get',
            url: `https://yxwpubmod.hntv.tv/mobile/cms/searchlivecomment?pageNo=1&pageSize=99&articleId=${atricleID}&idGreater=0&tenantId=hnr`,
        };

        const { data } = await axios(config);

        if (data.code === 0) {
            const arr = [];
            //筛选扩展字段
            for (const item of data.result.content) {
                const tag = {
                    id: item.id,
                    title: item.user,
                    picUrl: item.picUrl,
                    publishTime: item.publishTime,
                    content: item.content
                }
                arr.push(tag);
            }
            return {
                state: 1,
                message: "获取专题时间线数据成功！",
                data: arr
            }

        } else {
            return {
                state: 0,
                message: "初始化失败！0"
            }
        }

    } catch (error) {
        console.log(error);
        return {
            state: 0,
            message: "初始化失败！"
        }
    }
}

// 获取直播文章信息
export async function getZhiboInfo(atricleID) {
    try {
        const config = {
            method: 'get',
            url: `https://yxwpubmod.hntv.tv/mobile/cms/articlewithrelated?articleId=${atricleID}`,
        };

        const { data } = await axios(config);
        if (data.code === 0) {
            // 返回一个数组处理栏目名称和id
            const zhibo_info = {
                // 基础信息
                articleId: data.result.articleId,
                title: data.result.articleTitle,
                des: data.result.seoDescription,
                url: data.result.forwardingUrl,
                // 直播开始时间
                beginTime: data.result.liveBeginTime,
                closeTime: data.result.liveEndTime,

                // 预告片设置，只需要获取预告片状态即可，预告片时间目前无意义
                // 判断以直播时间为准
                previewedState: data.result.livePreviewedDto.state,
                previewedUrl: data.result.livePreviewedDto.priviewVideo,

                // 直播url,稿件关联多个直播间意义不明，所以只取第一个
                // 直播图片
                liveIMG: data.result.streams[0].livePic,
                // 直播地址是否可以实现切换？
                liveUrl: {
                    adr720: data.result.streams[0].adr_720,
                    adr1080: data.result.streams[0].adr_1080
                },
                backUrl: data.result.streams[0].backUrl,
                coverIMG: coverIMG(data.result.coverImagesList),
                // 播放量
                clickNum: data.result.clickNum
            }

            const result = {
                state: 1,
                message: "获取直播数据成功！",
                data: {
                    ...zhibo_info,
                }
            };

            console.log(result)

            return result

        } else {
            return {
                state: 0,
                message: "初始化失败！0"
            }
        }

    } catch (error) {
        console.log(error);
        return {
            state: 0,
            message: "初始化失败！"
        }
    }
}

// 获取直播消息列表
export async function getZhiboMessage(atricleID) {
    try {
        const config = {
            method: 'get',
            url: `https://yxwpubmod.hntv.tv/mobile/cms/searchlivecomment?articleId=${atricleID}&pageNo=1&pageSize=200`,
        };

        const { data } = await axios(config);
        if (data.code === 0) {
            const arr = [];
            for (const item of data.result.items) {
                arr.push({
                    id: item.articleLiveCommentId,
                    title: item.articleLiveCommentUser,
                    des: item.articleLiveCommentContent,
                    img: item.articleLiveCommentPicUrl,
                    time: item.articleLiveCommentTime,
                })
            }


            const result = {
                state: 1,
                message: "获取直播消息数据成功！",
                data: arr
            };

            console.log(result)

            return result

        } else {
            return {
                state: 0,
                message: "初始化失败！0"
            }
        }

    } catch (error) {
        console.log(error);
        return {
            state: 0,
            message: "初始化失败！"
        }
    }
}

// 获取客户端信息
export async function getDXArticles(atricleID, pageSize) {
    try {
        const config = {
            method: 'get',
            url: `https://pubmod.hntv.tv/mobile/cms/articles?channelId=${atricleID}&pageNo=1&pageSize=${pageSize}`,
        };

        const { data } = await axios(config);
        if (data.code === 0) {
            // 返回一个数组处理栏目名称和id
            const arr = [];

            //筛选扩展字段
            for (const item of data.result.content) {
                arr.push(handleDXArticles(item))
            }
            return {
                state: 1,
                message: "获取列表成功！",
                data: {
                    channelId: atricleID,
                    // 当前页数
                    page: data.result.pageNo,
                    // 总页数
                    totalPage: data.result.totalPage,
                    list: arr
                }
            }

        } else {
            return {
                state: 0,
                message: "获取列表失败！1"
            }
        }

    } catch (error) {
        console.log(error);
        return {
            state: 0,
            message: "获取列表失败！2"
        }
    }
}

// 获取栏目的扩展类型
export function handleEXT(ext, input, moren = false) {

    const res = ext.find(e => e.label == input);
    if (res) {
        // 转为字符串
        return res.fieldValue;
    } else {
        return moren
    }
}

function handleArticles(item) {
    // 无图3、三图2、双图4、大图1、单图0
    let articleType = 3;
    if (item.coverType !== 'null' && item.coverType) {
        articleType = isNaN(+item.coverType) ? 0 : +item.coverType;
    } else {
        articleType = handleArticleType(item.extFieldsList)
    }
    return {
        id: item.id,
        title: item.title,
        // 描述
        des: item.summary,
        // 来源
        from: item.origin,
        // 文章类型,默认类型级别最高,其次扩展类型
        articleType: articleType,
        // 是否是顶置文章
        top: item.topFlag === "1" ? true : false,
        publishDate: item.publishDate,
        // 封面图
        coverImagesList: item.coverImagesList.map((e) => {
            return {
                url: e.url,
                des: e.desc,
                // 是否是封面图
                coverBool: e.coverBool
            }
        }),
        url: item.articleType == 5 ? item.linkTo : item.forwardingUrl,
        type: item.articleType
    }
}

function handleDXArticles(item) {
    // 无图3、三图2、双图4、大图1、单图0
    let articleType = 3;
    if (item.coverType !== 'null' && item.coverType) {
        articleType = isNaN(+item.coverType) ? 0 : +item.coverType;
    } else {
        articleType = handleArticleType(item.extFieldsList)
    }
    return {
        id: item.id,
        title: item.title,
        // 描述
        des: item.summary,
        // 来源
        from: item.origin,
        // 文章类型,默认类型级别最高,其次扩展类型
        articleType: articleType,
        // 是否是顶置文章
        top: item.topFlag === "1" ? true : false,
        publishDate: item.publishDate,
        // 封面图
        coverImagesList: item.coverImagesList.map((e) => {
            return {
                url: e.url,
                des: e.desc,
                // 是否是封面图
                coverBool: e.coverBool
            }
        }),
        url: item.articleType == 5 ? item.linkTo : item.shareUrl,
        type: item.articleType
    }
}

function handleArticleType(ext) {
    const res = ext.find(e => e.label == '扩展类型');
    if (res) {
        // 转为字符串
        return +res.fieldValue;
    } else {
        return 0
    }
}

